import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import { getRandomIntInclusive } from "@intelligems/ig-utils";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

export const IgStackedAreaChartSkeleton = () => {
  const theme = useTheme();
  const fakeAreaData = [
    "Page A",
    "Page B",
    "Page C",
    "Page D",
    "Page E",
    "Page F",
    "Page G",
  ].map((point) => ({
    name: point,
    ...Object.fromEntries(
      [...Array(2).keys()].map((item) => [item, getRandomIntInclusive(1, 5)])
    ),
  }));
  const grayHexCodes = [
    theme.igPrimitives.gray[400],
    theme.igPrimitives.gray[600],
    theme.igPrimitives.gray[700],
    theme.igPrimitives.gray[900],
    theme.igPrimitives.gray["A200"],
    theme.igPrimitives.gray["A300"],
    theme.igPrimitives.gray["A400"],
    theme.igPrimitives.gray["A600"],
  ];
  return (
    <Grid>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart
          data={fakeAreaData}
          style={{ marginLeft: -24 }}
          margin={{ top: 5, bottom: 5 }}
        >
          <CartesianGrid
            style={{ stroke: theme.igBorders.core.disabled }}
            vertical={false}
          />
          <XAxis
            dataKey={"xAxisKey"}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            tickLine={false}
            tick={false}
          />
          <YAxis
            style={{ fontFamily: theme.typography.fontFamily, fontSize: 12 }}
            axisLine={{ stroke: theme.igBorders.core.disabled }}
            tickLine={false}
            tick={false}
          />
          {Object.keys(fakeAreaData).map((key, index) => (
            <Area
              className="infinite-pulsing"
              fillOpacity={1}
              key={key}
              type="monotone"
              dataKey={key}
              stackId="1"
              stroke={index > 7 ? "gray" : grayHexCodes[index]}
              fill={index > 7 ? "gray" : grayHexCodes[index]}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </Grid>
  );
};
